module.exports = __webpack_public_path__ + "error.2ca5fbb1.svg";